<template>
<div class="home">
  <h1>【個人ブログのためのSEOツール】キーワードの重要度比較</h1>
  <div class="input-area">
    <textarea placeholder="★ ここに比較したいページのURLを1行ごとに入力してください
★ 1件目を自分のサイトのページ、2件目以降を競合ページのURLとしてください
★ 最大5行まで比較できます（6行目以降は無視します）
例：
https://mysite.com/pineapple-1
https://rival-site.com/apple-1
https://competitor-site.com/banana-2
https://third-site.com/orange-3" v-model="urlsTextarea"></textarea>

    <button @click="handleStart" v-if="!isPending" :disabled="urlsTextarea == ''" >比較する</button>
    <div class="spin-block" v-if="isPending"><div class="spin"></div></div>
  </div>
  <hr>

  <div class="result-area">
    <div class="message" v-if="message">
      {{ message }}
    </div>
    <div v-if="showTable">
      <ResultTable :result="result"/>
    </div>
  </div>
  <Infomation />
</div>
</template>

<script>
import { ref } from "vue";
import ResultTable from '@/components/ResultTable.vue'
import Infomation from '@/components/Infomation.vue'
// import DisplayAdsbyGoogle from "@/components/DisplayAdsbyGoogle.vue";

export default {
  components: {
    ResultTable,
    Infomation,
    // DisplayAdsbyGoogle
},
  setup() {
    const isPending = ref(false);
    const showTable = ref(false);
    const message = ref('');
    const urlsTextarea = ref('');
    const result = ref('');
    // const api_url = 'http://localhost:8080';
    const api_url = 'https://asia-northeast1-extract-rival-keywords.cloudfunctions.net/ExtractRivalKeywords';

    const handleStart = async () => {
      //api call
      isPending.value = true;
      showTable.value = false;
      message.value = '';
      result.value = '';
      
      let urls = urlsTextarea.value.trim().split('\n');
      const urlsSet = new Set(urls.filter(x => x.trim() != '').map(x => x.trim()));
      urls = [...urlsSet].slice(0, 5);

      const res = await fetch(api_url, {
          method : 'POST', 
          // mode : 'cors',
          headers : { 'Content-Type': 'application/json'},
          body : JSON.stringify({urls : urls} )
      })
      const data = await res.json();
      if (res.ok) {
        showTable.value = true
      } else {
        message.value = data.message;
      }
      result.value = data;
      if (showTable.value && ((data.schema.fields.length - 2) != urls.length)) {
        message.value = '評価できなかったサイトがあります. URLが正しいか確認してください.'
      }

      isPending.value = false;
      urlsTextarea.value = urls.join('\n');
    }

    return {isPending, handleStart, urlsTextarea, result, showTable, message}
  }
}
</script>

<style>
  .home {
    margin: 10px;
  }
  .input-area {
    /* text-align: center; */
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
  }
  .result-area {
    margin: 10px auto;
  }

  textarea {
    width: 100%;
    /* display: block; */
    padding: 5px;
    margin: 20px auto;
    height: 200px;
    border: 1px solid var(--secondary);
    box-sizing: border-box;
    border-radius: 8px;
  }

  .input-area button {
    width: 50%;
    letter-spacing: 0.5rem;
  }
  .input-area .spin-block {
    width: 50%;
  }
  .message {
    color: var(--warning);
  }


</style>

